import {
  FETCH_CORE_ATTRIBUTES_REQUEST,
  FETCH_CORE_ATTRIBUTES_SUCCESS,
  FETCH_CORE_ATTRIBUTES_FAILURE,
  DELETE_CORE_ATTRIBUTES_SUCCESS,
  DELETE_CORE_ATTRIBUTES_REQUEST,
  DELETE_CORE_ATTRIBUTES_FAILURE,
  UPDATE_CORE_ATTRIBUTES_REQUEST,
  UPDATE_CORE_ATTRIBUTES_SUCCESS,
  UPDATE_CORE_ATTRIBUTES_FAILURE,
  CREATE_CORE_ATTRIBUTES_FAILURE,
  CREATE_CORE_ATTRIBUTES_SUCCESS,
  CREATE_CORE_ATTRIBUTES_REQUEST,
} from "../constants/actionTypes";

const initialState = {
  loading: false,
  data: [],
  error: null,
  deleteLoading: false,
};

const coreAttributesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CORE_ATTRIBUTES_REQUEST:
      return {
        ...state,
        loading: true,
        // deleteLoading: true,
      };

    case FETCH_CORE_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case FETCH_CORE_ATTRIBUTES_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        error: action.error,
      };

    case DELETE_CORE_ATTRIBUTES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case DELETE_CORE_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case DELETE_CORE_ATTRIBUTES_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        error: action.error,
      };

    case UPDATE_CORE_ATTRIBUTES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_CORE_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case UPDATE_CORE_ATTRIBUTES_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        error: action.error,
      };
    case CREATE_CORE_ATTRIBUTES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CREATE_CORE_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case CREATE_CORE_ATTRIBUTES_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default coreAttributesReducer;
